import styled from "styled-components";
import { colors, easing, layout, media, radii, shadows } from "../../../theme";
import { FadeImage } from "../../general/FadeImage";

export const HomePresentationContainer = styled.section`
  padding: clamp(4.5rem, 9vw, 7.5rem) ${layout.gutter};
  background-color: ${({ $tinted }) =>
    $tinted ? colors.backgroundTernary : colors.backgroundSecondary};
`;

export const HomePresentationInner = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: clamp(3rem, 7vw, 6rem);
  max-width: ${layout.maxWidth};
  margin: 0 auto;

  > :first-child {
    order: ${({ $imageOnLeft }) => ($imageOnLeft ? 0 : 1)};
  }

  ${media.mobile} {
    grid-template-columns: 1fr;
    gap: 2.5rem;

    > :first-child {
      order: 0;
    }
  }
`;

export const HomePresentationImageFrame = styled.div`
  position: relative;
  aspect-ratio: 5 / 4;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border: 2px solid ${colors.primary};
    border-radius: ${radii.lg};
    transform: translate(
      ${({ $imageOnLeft }) => ($imageOnLeft ? "-1.25rem" : "1.25rem")},
      1.25rem
    );
    transition: transform 0.8s ${easing.out};
  }

  &:hover::before {
    transform: translate(
      ${({ $imageOnLeft }) => ($imageOnLeft ? "-0.75rem" : "0.75rem")},
      0.75rem
    );
  }

  ${media.mobile} {
    &::before {
      transform: translate(0.75rem, 0.75rem);
    }
  }
`;

export const HomePresentationImage = styled(FadeImage)`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${radii.lg};
  box-shadow: ${shadows.md};
`;

export const HomePresentationContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
`;
